<div class="modal fade" id="contractsModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" #closeButton class="btn-close btn-sm" data-bs-dismiss="modal"
                    aria-label="Close"></button>
            </div>
            <div class="bg-primary border-bottom border-primary-subtle px-3 py-1" style="--bs-bg-opacity: .2;">
                <div class="row g-1 mb-1">
                    <div class="col-sm-4">
                        <label class="form-label">Customer</label>
                        <input type="text" class="form-control form-control-sm" disabled
                            value="{{contractParameters.customerName}}" />
                    </div>
                    <div class="col-sm-4">
                        <label class="form-label">{{locationType}}</label>
                        <input type="text" class="form-control form-control-sm" disabled
                            value="{{contractParameters.locationName}}" />
                    </div>
                    <div class="col-sm-3">
                        <label class="form-label">City</label>
                        <input type="text" class="form-control form-control-sm" disabled
                            value="{{contractParameters.locationCity}}" />
                    </div>
                    <div class="col-sm-1">
                        <label for="commodity" class="form-label">Comm</label>
                        <input type="text" class="form-control form-control-sm" disabled
                            value="{{contractParameters.commodity}}" />
                    </div>
                </div>
            </div>
            <div class="modal-body">
                <div class="container-fluid">
                    <div class="d-flex align-items-center p-3" *ngIf="loading">
                        <strong role="status">Loading...</strong>
                        <div class="spinner-border ms-auto" aria-hidden="true"></div>
                    </div>
                    <div *ngIf="loading == false">
                        <h6>Open Contracts for Time Period</h6>
                        <div class="mb-4 border rounded p-1">
                            <table class="table table-sm" style="margin-bottom: 0">
                                <thead>
                                    <tr>
                                        <th class="text-nowrap">Contract#</th>
                                        <th class="text-nowrap">Begin Date</th>
                                        <th class="text-nowrap">End Date</th>
                                        <th>Delivered Basis</th>
                                        <th>Price</th>
                                        <th class="text-center">Quantity</th>
                                        <th class="text-center text-nowrap">Open Qty</th>
                                        <th class="text-center">Loads</th>
                                        <th class="text-center">Open Loads</th>
                                        <th>Cust Contract</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container
                                        *ngIf="contracts.periodContracts.length > 0; else noOpenContractsRecords">
                                        <tr *ngFor="let contract of contracts.periodContracts">
                                            <td>{{contract.contractNumber}}</td>
                                            <td>{{contract.periodBeginDate}}</td>
                                            <td>{{contract.periodEndDate}}</td>
                                            <td>{{contract.termLocation}}</td>
                                            <td class="text-end">{{contract.price}}</td>
                                            <td class="text-end text-nowrap">{{contract.quantity}}</td>
                                            <td class="text-end text-nowrap">{{contract.openQuantity}}</td>
                                            <td class="text-end">{{contract.loadsDisplay}}</td>
                                            <td class="text-end">{{contract.openLoads}}</td>
                                            <td>{{contract.customerContract}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="5">&nbsp;</td>
                                            <td class="text-end fw-bold">{{contracts.periodTotals.quantity}}</td>
                                            <td class="text-end fw-bold">{{contracts.periodTotals.openQuantity}}</td>
                                            <td class="text-end fw-bold">{{contracts.periodTotals.loadsDisplay}}</td>
                                            <td class="text-end fw-bold">{{contracts.periodTotals.openLoads}}</td>
                                            <td>&nbsp;</td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                            <ng-template #noOpenContractsRecords>
                                <tr>
                                    <td colspan="10" class="text-center">
                                        No records found
                                    </td>
                                </tr>
                            </ng-template>
                        </div>

                        <h6>Remaining Open Contracts</h6>
                        <div class="border rounded mb-2 p-1">
                            <table class="table table-sm" style="margin-bottom: 0">
                                <thead>
                                    <tr>
                                        <th>Contract #</th>
                                        <th>Begin Date</th>
                                        <th>End Date</th>
                                        <th>Delivered Basis</th>
                                        <th>Price</th>
                                        <th class="text-center">Quantity</th>
                                        <th class="text-center">Open Qty</th>
                                        <th class="text-center">Loads</th>
                                        <th class="text-center">Open Loads</th>
                                        <th>Cust Contract</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container
                                        *ngIf="contracts.otherContracts.length > 0; else noRemainingContractsRecords">

                                        <tr *ngFor="let contract of contracts.otherContracts">
                                            <td>{{contract.contractNumber}}</td>
                                            <td>{{contract.periodBeginDate}}</td>
                                            <td>{{contract.periodEndDate}}</td>
                                            <td>{{contract.termLocation}}</td>
                                            <td class="text-end">{{contract.price}}</td>
                                            <td class="text-end">{{contract.quantity}}</td>
                                            <td class="text-end">{{contract.openQuantity}}</td>
                                            <td class="text-end">{{contract.loadsDisplay}}</td>
                                            <td class="text-end">{{contract.openLoads}}</td>
                                            <td>{{contract.customerContract}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="5">&nbsp;</td>
                                            <td class="text-end fw-bold">{{contracts.otherTotals.quantity}}</td>
                                            <td class="text-end fw-bold">{{contracts.otherTotals.openQuantity}}</td>
                                            <td class="text-end fw-bold">{{contracts.otherTotals.loadsDisplay}}</td>
                                            <td class="text-end fw-bold">{{contracts.otherTotals.openLoads}}</td>
                                            <td>&nbsp;</td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                            <ng-template #noRemainingContractsRecords>
                                <tr>
                                    <td colspan="10" class="text-center">
                                        No records found
                                    </td>
                                </tr>
                            </ng-template>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>